import React, { useEffect, useState } from "react";
import "./Cart.scss";
import { Button, Col, Form, Image, ListGroup, Row } from "react-bootstrap";
import { CartItem } from "./cart-interface";
import nvCookieHelpers from "../../services/cookieService";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import RTXImage from "../../assets/images/gfn-ecosystem-kv-4-300x200.jpg";
import { useHeaderMenu } from '../../contexts/login.context';
import { useLocalization } from '../../contexts/LocalizationContext';

interface Props {
  onCartChange: (fieldName: number, value: number) => void;
  validationErrors: Record<string, string>;
  onPromoChange: (fieldName: string, value: any) => void;
  onPromoSubmit: (value: any) => void;
  onPromoDelete: (value: any) => void;
  isDownload: boolean;
  isVerify: boolean;
  isThanks: boolean;
  cartData: any;
  promoCodeError: boolean;
}
interface iShippingMethod {
  "description": string;
  "formattedCost": string;
  formattedCostWithDiscount?: string;
  cost?: {
    currency: string;
    value: number;
  };
  costWithDiscount?: {
    currency: string;
    value: number;
  };
}
const Cart: React.FC<Props> = ({ onCartChange, validationErrors, onPromoChange, onPromoSubmit, onPromoDelete, isDownload, isVerify, cartData, isThanks, promoCodeError }) => {
  const { isPartner } = useHeaderMenu();
  const { showTax } = useLocalization();
  const [orderNum, setOrderNum] = useState("");
  const [subTotal, setSubTotal] = useState("0");
  const [shippingTotal, setshippingTotal] = useState<iShippingMethod | null>(null)
  const [taxTotal, settaxTotal] = useState<string | null>(null)
  const [total, settotal] = useState<string | null>(null)
  const [promo, setPromo] = useState<string | undefined>(undefined)
  const [cart, setCart] = useState<CartItem[]>([]);
  const [outOfStock, setOutofStock] = useState<boolean>(false)
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isValid, setIsValid] = useState<boolean>(true);
  const [isRTXChild, setRTXChild] = useState<boolean>(false);
  const [couponApplied, setCouponApplied] = useState<boolean>(false);
  const { state } = useLocation();
  const locale = window.location.pathname.split('/')[1];
  const userType = state ? state.user : sessionStorage.getItem('userType');
  const boldClassName = (!isThanks && !isVerify) ? 'bold' : '';
  const [showSubTotalAndTax, setShowSubTotalAndTax] = useState<boolean>(true);

  const emptyCart = (msg: string, pid: number) => {
    navigate(`/${locale}/software/cart/empty`, { state: { msg, pid } })
  };

  // const isDigital = cartData?.cartItems?.cartItem?.map(item => item.product.productType?.toUpperCase() === 'DIGITAL').length > 0
  const isDigital = cartData?.cartItems?.cartItem?.some(
    item => item.product.productType?.toUpperCase() === 'DIGITAL'
  );

  const getSubTotalByLocale = (subTotal: string, total: string) => {
    if (['de-de', 'fr-fr', 'it-it', 'es-es', 'en-gb', 'en-eu'].includes(locale) || !subTotal) {
      if (isThanks || isVerify) {
        return subTotal;
      }
      return total;
    }
    return subTotal;
  }
  useEffect(() => {
    if (['de-de', 'fr-fr', 'it-it', 'es-es', 'en-eu'].includes(locale) && !isDigital) {
      setShowSubTotalAndTax(false);
    }
  }, [locale, isDigital]);

  useEffect(() => {
    let cartState, orderNumber, shipping, subTotal, customatts, matchingNames;
    let orderObj = nvCookieHelpers.getCookie('nvHeadless');
    let tmpcart = orderObj ? orderObj['cart'] : [];
    cartState = cartData["cartItems"]["cartItem"];
    subTotal = getSubTotalByLocale(cartData["pricing"]["formattedSubtotal"], cartData["pricing"]["formattedOrderTotal"]);
    customatts = cartData?.customAttributes?.attribute;
    const isCouponApplied = cartState.some((item) => item.pricing.formattedSalePriceWithQuantity !== item.pricing.formattedListPriceWithQuantity);
    setCouponApplied(isCouponApplied);
    // let shippingAtts = cartState['product'].customAttributes?.attribute;
    // Define a separate function outside the loop
    const insertNewCartItem = (itemObj: { name: string; id: number }) => {
      // const newCartItemIndex = cartState.length; // Index to add new items
      setOutofStock(true);
      cartState = [
        ...cartState,
        {
          "pricing": {
            "formattedListPrice": t('OUT_OF_STOCK'), // You may adjust this as needed
            "formattedListPriceWithQuantity": t('OUT_OF_STOCK'), // You may adjust this as needed
          },
          "product": {
            "displayName": itemObj.name,
            "id": itemObj.id, // Set a unique id or adjust as needed
            "longDescription": null,
            "maximumQuantity": null,
            "minimumQuantity": null,
            "name": itemObj.name,
            "productImage": "", // Provide an image URL or adjust as needed
            "productType": "CUSTOM", // Set a custom type or adjust as needed
            "shortDescription": null
          },
          "quantity": null // Set the quantity to 1 or adjust as needed
        }
      ];
    };
    if (customatts) {
      for (let i = 0; i < customatts.length; i++) {
        if (customatts[i].name === 'message_driver' && tmpcart) {
          // Split the string using the semicolon as the delimiter
          let idsToMatch = customatts[i].value.split(';').map(id => parseInt(id, 10));
          matchingNames = tmpcart.filter(item => idsToMatch.includes(item.id)).map(item => ({ id: item.id, name: item.name }));
          // Log the extracted values
          tmpcart = tmpcart.filter(item => idsToMatch !== item.id);
          if (orderObj) {
            orderObj['cart'] = tmpcart;
            console.log('tmpcart==>', tmpcart);
            nvCookieHelpers.setCookie('nvHeadless', JSON.stringify(orderObj));
          } else {
            let updatedCart = { cart: tmpcart, lastAction: null };
            nvCookieHelpers.setCookie('nvHeadless', JSON.stringify(updatedCart));
          }
          // Insert each matching name into cartState array using the external function
          if (!isVerify && !isThanks) {
            if (cartState && cartState.length) {
              matchingNames.forEach(insertNewCartItem);
            } else {
              let str: string;
              if (matchingNames && matchingNames.length > 1) {
                str = "We're sorry, the products you are trying to purchase are currently out of stock.";
              } else {
                str = "We're sorry, " + matchingNames[0]['name'] + "is currently out of stock."
              }
              emptyCart(str, Number(idsToMatch));
            }
          }
        };
      }
    }
    if (!(cartData.isDigital)) {
      if (cartData.shippingMethod) {
        // Get the shipping method code
        const shippingMethodCode = Number(cartData.shippingMethod.code);

        // Get the selected shipping option
        const selectedShippingOption = (shippingMethodCode !== undefined && shippingMethodCode !== null && cartData?.shippingOptions?.shippingOption.length) ? (cartData?.shippingOptions?.shippingOption?.find(
          option => option.id === shippingMethodCode
        )) : undefined;
        if (selectedShippingOption) {
          setshippingTotal(selectedShippingOption);
        }
      } else {
        shipping = cartData["pricing"]["formattedShippingAndHandling"]
        setshippingTotal({
          "description": 'Shipping',
          "formattedCost": shipping
        })
      }
      let cartState = cartData?.cartItems?.cartItem;
      if (cartState && cartState.length > 0) {
        for (let i = 0; i < cartState.length; i++) {
          const productCustomAttributes = cartState[i].product.customAttributes?.attribute;
          if (cartState[i].product.productType === 'DOWNLOAD' && !cartState.isDigital) {
            if (productCustomAttributes) {
              for (let j = 0; j < productCustomAttributes.length; j++) {
                // Check for specific attribute and value
                if (productCustomAttributes[j].name === 'is40SeriesChild' && productCustomAttributes[j].value === 'true') {
                  cartState[i]["pricing"]["formattedListPriceWithQuantity"] = t('nvidiaSI_FREE_INCLUDED');
                  setRTXChild(true);
                }
              }
            }
          }
        }
      }
    }
    setCart(cartState);
    setOrderNum(orderNumber);
    setSubTotal(subTotal);
    settaxTotal(cartData['pricing']['formattedTax']);
    settotal(cartData['pricing']['formattedOrderTotal']);

    // setshippingTotal(cartData['pricing']['formattedShippingAndHandling']);
    // itemCount=cartData["totalItemsInCart"];
    if (cartData["cartId"]) {
      orderNumber = cartData["cartId"];
      setOrderNum(orderNumber);
    } else {
      orderNumber = cartData["order"]["id"];
      setOrderNum(orderNumber);
    }
    if (validationErrors?.promoCode) {
      setIsValid(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, isThanks, isVerify, t, validationErrors?.promoCode]);
  useEffect(() => {
    if (!couponApplied) {
      setPromo('');
    }
  }, [couponApplied])
  const handlePromoChange = (field: string, val: string) => {
    onPromoChange(field, val);
    setPromo(val);
  }
  const handlePromoDelete = (c: boolean) => {
    onPromoDelete(c);
  }
  const handlePromoSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onPromoSubmit(promo);
  }
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleOptionChange = (productId, selectedOption) => {
    setOutofStock(false);
    cartData = null;
    setSelectedOptions({
      ...selectedOptions,
      [productId]: selectedOption,
    });
    onCartChange(productId, selectedOption); // Notify the parent component about the form change
  };
  const handleCartChange = () => {
    console.log('Verify User Page', userType);
    if (nvCookieHelpers.getCookie('isUserLoggedIn')) {
      navigate(`/${locale}/software/cart/user/loggedIn`)
    } else {
      navigate(`/${locale}/software/cart/user/guest`)
    }
  }

  const cartClassName = isDownload ? "digitalCart" : "physicalCart";
  const thanksClassName = isThanks ? 'cartThanks' : '';
  const localeClass = () => {
    if (locale === 'en-us') {
      return 'us';
    } else if (locale === 'de-de') {
      return 'germany';
    } else if (locale === 'fr-fr') {
      return 'france';
    } else if (locale === 'it-it') {
      return 'italy';
    } else if (locale === 'es-es') {
      return 'spain';
    } else {
      return 'britain';
    }
  };
  const borderLineClassnames = (!isThanks && !isVerify) ? 'borderLine' : '';
  let cartHeading;
  if (isDownload) {
    cartHeading = <h3 id="cartHeading">{t('SHOPPING_CART_HEADER')}</h3>;
  } else if (isVerify) {
    cartHeading = (
      <div className="cartHeading">
        <h3 id="cartHeading">{t("ORDER_SUMMARY")}</h3>
        <button
          type="button"
          onClick={handleCartChange}
          className="continue"
          aria-label={t('BTN_EDIT_CAPS')}
        >
          {t('BTN_EDIT_CAPS')}
        </button>
      </div>
    );
  } else {
    cartHeading = (
      <div className="cartHeading">
        <h3 id="cartHeading">{t("ORDER_SUMMARY")}</h3>
      </div>
    );
  }
  return (
    <div className="cartDetails" role="region" aria-labelledby="cartHeading">
      {outOfStock && <div className="text-danger" role="alert" aria-live="assertive">
        <p className="mb-4">We're sorry, but your cart has been modified, due to a product being out of stock or limited in quantity</p>
      </div>}
      <Row xs={'auto'} md={'auto'} className="dr_cart_title mt-4">
        <Col md={6} sm={6} className="p-0">
          {cartHeading}
        </Col>
        <Col md={6} sm={6} className="p-0">
          {!isPartner && <span id="dr_orderNumber" className="pull-right" aria-label={`${t('ORDER_TEXT')}: ${orderNum}`}>{t('ORDER_TEXT')}: {orderNum}</span>}
        </Col>
      </Row>
      {cart?.length && (
        <Row xs={'auto'} md={'auto'} className="mb-4">
          <Col md={12} sm={12}>
            <ListGroup className={`${cartClassName} orderItems`}>
              {cart.map((item, index) => (
                <ListGroup.Item className={`${thanksClassName} items ${borderLineClassnames}`} key={item["product"]["id"]} role="group" aria-labelledby={`productTitle-${item["product"]["id"]}`}>
                  <Form className="orderItemForm" >
                    <div className={item['quantity'] ? `itemDetails` : `oos itemDetails`}>
                      {item["quantity"] && !isDigital ? (
                        item["product"]["productImage"] ? (
                          <div className="thumbnailImage">
                            <Image src={item["product"]["productImage"]}
                              alt={item["product"]["displayName"]}
                              className="boxArt" fluid />
                          </div>
                        ) : (
                          <div className="thumbnailImage">
                            <div className="blankImage" aria-hidden="true"></div>
                          </div>
                        )
                      ) : (
                        <div className="thumbnailImage">
                          <div className="blankImage" aria-hidden="true"></div>
                        </div>)
                      }
                      <div className="productTitle" id={`productTitle-${item["product"]["id"]}`}>
                        <span className="title">
                          {item["product"]["displayName"]}
                        </span>
                        {item["product"]["productType"] !== 'OTHER' &&
                          item["product"]["customAttributes"] &&
                          item["product"]["customAttributes"]["attribute"] &&
                          !item["product"]["customAttributes"]["attribute"].some(attr =>
                            attr.name === 'is40SeriesChild' && attr.value === 'true') ? (
                          item["product"]["maximumQuantity"] ? (!isThanks && !isVerify &&
                            <p className="additionalMsg">
                              {t('LIMIT_PER_CUSTOMER', { x: item.limitPerCustomer ? item.limitPerCustomer : item["product"]["maximumQuantity"] })}
                            </p>
                          ) : ''
                        ) : ''}
                        {item["product"]["productType"] !== 'OTHER' &&
                          item["product"]["customAttributes"] &&
                          item["product"]["customAttributes"]["attribute"] &&
                          !item["product"]["customAttributes"]["attribute"].some(attr =>
                            attr.name === 'is40SeriesChild' && attr.value === 'true'
                          ) ? (
                          (!isThanks && !isDownload && !isVerify) && (
                            <button
                              type="button"
                              className="continue productRemove"
                              onClick={(e) => handleOptionChange(item["product"]["id"], item["quantity"] ? 0 : -1)}
                              aria-label={`${t('BTN_REMOVE')} ${item["product"]["displayName"]}`}
                            >
                              {t('BTN_REMOVE')}
                            </button>
                          )
                        ) : ''
                        }
                        {item["quantity"] ? (item["product"]["productType"] === 'OTHER' || isThanks || isVerify) && <p aria-label={`${t('INVOICE_PRODUCT_QUANTITY')} ${item["quantity"]}`}>{t('INVOICE_PRODUCT_QUANTITY')} {item["quantity"]}</p> : ''}
                      </div>
                      {item["quantity"] && (
                        <div className="quantitySelector">
                          {(!isThanks && !isVerify) && (
                            <Form.Group className="orderQuantity">
                              {(isDownload || item["product"]["maximumQuantity"] > 1) && (
                                <>
                                  <span
                                    id={`label-shopperQuantity-${item["product"]["id"]}`}
                                    className="visually-hidden"
                                  >
                                    {t('INVOICE_PRODUCT_QUANTITY_COLON')} {item["product"]["displayName"]}
                                  </span>
                                  <Form.Select
                                    autoComplete="none"
                                    aria-labelledby={`label-shopperQuantity-${item["product"]["id"]}`}
                                    value={selectedOptions[item.id] || item["quantity"]}
                                    onChange={(e) =>
                                      handleOptionChange(
                                        item["product"]["id"],
                                        parseInt(e.target.value, 10)
                                      )
                                    }
                                    id={`shopperQuantity-${item["product"]["id"]}`}
                                  >
                                    {[
                                      ...Array(item["product"]["maximumQuantity"]).keys(),
                                    ].map((index) => (
                                      <option key={index} value={index + 1}>
                                        {index + 1}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </>
                              )}
                            </Form.Group>
                          )}
                        </div>
                      )}
                      {item["quantity"] ? (<div className="itemPrice">
                        <div className="productPrice">
                          <p className={`${boldClassName} price`}>
                            {(((item["product"]["productType"] !== 'OTHER' &&
                              item["product"]["customAttributes"] &&
                              item["product"]["customAttributes"]["attribute"] &&
                              !item["product"]["customAttributes"]["attribute"].some(attr =>
                                attr.name === 'is40SeriesChild' && attr.value === 'true')) || isPartner)
                              && item["pricing"]["formattedSalePriceWithQuantity"] !== item["pricing"]["formattedListPriceWithQuantity"]) ?
                              (<><span className="strikethrough">{item["pricing"]["formattedListPriceWithQuantity"] ? item["pricing"]["formattedListPriceWithQuantity"] : 0}</span>
                                <span>{item["pricing"]["formattedSalePriceWithQuantity"] ? item["pricing"]["formattedSalePriceWithQuantity"] : 0}</span></>) :
                              (<span>{item["pricing"]["formattedListPriceWithQuantity"] ? item["pricing"]["formattedListPriceWithQuantity"] : 0}</span>)
                            }
                          </p>
                          {!isThanks && !isVerify && item && item["quantity"] > 1 && (
                            <p>
                              (
                              {item["pricing"]["formattedListPrice"] ? item["pricing"]["formattedListPrice"] : 0} {t('EACH')})
                            </p>
                          )}
                        </div>
                      </div>) : <button type="button" className="cart__remove__button" onClick={(e) => handleOptionChange(item["product"]["id"], item["quantity"] ? 0 : -1)} aria-label={`${t('BTN_REMOVE')} ${item["product"]["displayName"]}`}></button>}
                    </div>
                  </Form>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row>
      )}
      <Row xs={'1'} md={'1'} className="cartPricing">
        {(!isThanks && !isVerify) && (
          <Col md={isDownload ? 6 : 12} className="p-0 borderLine">
            <Form.Group className="mb-3">
              <Form.Label htmlFor="promoCode" className="visually-hidden">
                {t('COUPON_CODE_TEXT')}
              </Form.Label>
              <span
                id="dr_promoCouponCodeNew"
                className={(!isValid && promoCodeError) ? 'is-invalid' : ''}
              >
                {/* REMOVE htmlFor to avoid double-labeling */}
                <Form.Label className="visually-hidden" id="promoCodeLabel">
                  {t('COUPON_CODE_TEXT_COLON')}
                </Form.Label>

                <Form.Control
                  type="text"
                  autoComplete="none"
                  name="couponCode"
                  value={promo}
                  id="promoCodeField"
                  placeholder={t('COUPON_CODE_TEXT')}
                  className="mb-2"
                  isInvalid={!!validationErrors?.promoCode}
                  aria-invalid={!!validationErrors?.promoCode}
                  aria-labelledby="promoCodeLabel"
                  aria-describedby={validationErrors?.promoCode ? 'promoCodeError' : undefined}
                  onBlur={(e) => handlePromoChange('promoCode', e.target.value)}
                  onChange={(e) => handlePromoChange('promoCode', e.target.value)}
                />

                <Button
                  type="button"
                  id="promoDR_Button"
                  className="dr_button"
                  onClick={handlePromoSubmit}
                  aria-label={`${t('BTN_APPLY')} ${t('COUPON_CODE_TEXT_COLON')}`}
                >
                  {t("BTN_APPLY")}
                </Button>
              </span>

              {validationErrors?.promoCode && (
                <Form.Control.Feedback type="invalid" id="promoCodeError" aria-live="polite">
                  {validationErrors.promoCode}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
        )}
        <Col md={isDownload ? 6 : 12} className="pricings p-0">
          {(isThanks || isVerify) &&
            <>
              {showSubTotalAndTax && <p>
                <span>{t('nvidiaSI_SUBTOTAL_HEADING')}:</span>
                <span className="dr_price dr_totals">{subTotal}</span>
              </p>}
              {!isDigital && shippingTotal && (shippingTotal?.formattedCostWithDiscount || shippingTotal?.formattedCost) && (
                <p className="shipping">
                  <span>{`${t('CHECKOUT_SHIPPING')} (${shippingTotal?.description})`}:</span>
                  {
                    (shippingTotal?.formattedCostWithDiscount && shippingTotal?.formattedCost !== shippingTotal?.formattedCostWithDiscount) ? (
                      <span className="dr_price dr_totals">{shippingTotal?.formattedCostWithDiscount}</span>
                    ) : (
                      <span className="dr_price dr_totals">{shippingTotal?.formattedCost}</span>
                    )
                  }
                </p>
              )}
              {locale !== 'en-af' && locale !== 'es-la' && locale !== 'es-mx' && locale !== 'pt-br' && locale !== 'en-hk' && locale !== 'en-me' && showTax && taxTotal && showSubTotalAndTax && (
                <p className="tax">
                  <span>{t('TAX')}</span>
                  <span className="dr_price dr_totals">{taxTotal}</span>
                </p>
              )}
            </>
          }
          {(!isThanks && !isVerify) && (
            <>
              {couponApplied && (
                <p className="couponDiscount">
                  <span className="couponHeading">{t('DISCOUNT_COUPON')}:</span>
                  <span className="dr_price dr_totals">
                    <label htmlFor="couponRemove" className="couponRemove"><p id="couponRemove" onClick={() => handlePromoDelete(couponApplied)}>{t('BTN_REMOVE_CODE')}</p></label>
                  </span>
                </p>
              )}
              {shippingTotal && (shippingTotal?.formattedCostWithDiscount || shippingTotal?.formattedCost) && (
                <p className="shipping">
                  <span>{`${t('CHECKOUT_SHIPPING')} (${shippingTotal?.description})`}:</span>
                  {
                    (shippingTotal?.formattedCostWithDiscount && shippingTotal?.formattedCost !== shippingTotal?.formattedCostWithDiscount) ? (
                      <span className="dr_price dr_totals">{shippingTotal?.costWithDiscount?.value === 0.00 ? t('nvidiaSI_FREE_INCLUDED') : shippingTotal?.formattedCostWithDiscount}</span>
                    ) : (
                      <span className="dr_price dr_totals">{shippingTotal?.cost?.value === 0.00 ? t('nvidiaSI_FREE_INCLUDED') : shippingTotal?.formattedCost}</span>
                    )
                  }
                </p>
              )}
              <p className="total pt-2">
                <span className="subTotalHeading">{(locale === 'en-us' || locale === 'en-ca'|| locale === 'nb-no') ? t('nvidiaSI_SUBTOTAL_HEADING') : t('nvidiaSI_TOTAL_HEADING')}</span>
                {t('GENERIC_TAX_VERB') === 'GENERIC_TAX_VERB' && (
                  <>
                    {locale !== 'pl-pl' && (
                      (locale === 'en-us' || locale === 'en-ca') ? (
                        <span className="taxations">&nbsp;({t('TAX_NOT_INCLUDED').toLowerCase()})</span>
                      ) : (
                        <span className="taxations">&nbsp;({(isDigital) ? t('VAT_INCLUDED_DIGITAL') : t('VAT_INCLUDED_PHYSICAL')})</span>
                      )
                    )}
                  </>
                )}:&#160;
                <span className={`${localeClass()} dr_price dr_totals`}>{locale === 'en-us' || locale === 'en-ca' || locale === 'nb-no' ? subTotal : total}</span>
              </p>
            </>
          )}
          {(isThanks || isVerify) && total && (
            <p className="priceTotal pt-2">
              <span className="cartTotals">{t('nvidiaSI_TOTAL_HEADING')}</span>
              {((isVerify ||
                locale === 'en-eu' || locale === 'es-es' || locale === 'fr-fr' || locale === 'it-it' || locale === 'de-de') &&
                locale !== 'en-us' && locale !== 'en-ca' && locale !== 'ja-jp') && t('GENERIC_TAX_VERB') === 'GENERIC_TAX_VERB' && (
                  <>
                    {locale !== 'pl-pl' && (
                      <span className="taxations">&nbsp;({isDigital ? t('VAT_INCLUDED_DIGITAL') : t('VAT_INCLUDED_PHYSICAL')})</span>
                    )}
                  </>
                )}:&#160;
              <span className={`${localeClass()} dr_price dr_totals`}>{total}</span>
            </p>
          )}
        </Col>
        {t('GENERIC_TAX_VERB') !== 'GENERIC_TAX_VERB' && <Col md="12" className="pricings p-0">({t('GENERIC_TAX_VERB')})</Col>}
      </Row>
      {
        isRTXChild && isThanks && <Row xs={'auto'} md={'auto'}>
          <Col md={12} className="isRTXChild">
            <p>Based on your selection, you might be interested in </p>
            <a href="https://www.nvidia.com/en-us/geforce-now/?nvid=nv-int-store-order-bn-tryfree" className="continue">GeForce NOW :</a>
            <a href="https://www.nvidia.com/en-us/geforce-now/?nvid=nv-int-store-order-bn-tryfree"><Image src={RTXImage} alt="isRTXChild"></Image></a>
          </Col>
        </Row>
      }
    </div >
  );
};
export default React.memo(Cart);
